var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"ma-0 pa-0"},[_c('hero',{attrs:{"title":"Store"}}),_c('v-row',[_c('v-col',{staticClass:"mt-10 ma-3 about-text"},[_c('p',[_c('strong',[_vm._v("Coming Soon!")])])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }